"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEditorSessionManager = void 0;
const lodash_1 = require("lodash");
const types_1 = require("./types");
const constants_1 = require("./constants");
const noop = () => undefined;
const createEditorSessionManager = (config) => {
    // TODO figure out what to do with `isViewerFragment`, `fetchApi`, `logger`
    // until then we receive it from thunderbolt IOC from `Fetch`, `isViewerFragmentSymbol`, `LoggerSymbol` symbols
    const isViewerFragment = !!config.isViewerFragment;
    const fetchFn = config?.envFetch ?? globalThis.fetch;
    const logger = config.logger;
    const { site, mode: { debug }, } = config;
    const window = globalThis.window;
    let sessionTimeoutPointer;
    const onLoadSessionCallbacks = new Set();
    const addLoadNewSessionCallback = (callback) => {
        onLoadSessionCallbacks.add(callback);
        return () => onLoadSessionCallbacks.delete(callback);
    };
    const sessionModelState = config.sessionModel;
    const getSessionModel = () => Object.keys(sessionModelState).length > 0 ? sessionModelState : config.sessionModel;
    const getMetaSiteInstance = () => {
        const metaSiteAppDefinitionId = config.clientSpecMap[constants_1.META_SITE_APP_ID];
        const metaSiteApp = getSessionModel()[metaSiteAppDefinitionId];
        return (metaSiteApp && metaSiteApp.instance) || config.metaSiteInstance;
    };
    const fetchDynamicModel = async () => {
        let res;
        try {
            res = await fetchFn(config.dynamicModelApiUrl, {
                credentials: 'same-origin',
                headers: { authorization: getMetaSiteInstance() },
            });
        }
        catch (err) {
            throw new types_1.FetchDynamicModelFailedError('Network error: ' + err.message);
        }
        const requestId = res.headers?.get('X-Wix-Request-Id') || '';
        if (res.status < 200 || res.status >= 300) {
            throw new types_1.FetchDynamicModelFailedError(`Fetch failed with HTTP status ${res.status}`, requestId);
        }
        let data;
        try {
            data = await res.json();
        }
        catch (ex) {
            throw new types_1.FetchDynamicModelFailedError('Non-json response', requestId);
        }
        return (0, lodash_1.mapValues)((0, lodash_1.mapKeys)(data, 'appDefinitionId'), clientSpec => (0, lodash_1.pick)(clientSpec, 'instance'));
    };
    const invokeSessionLoadCallbacks = (reason) => {
        const instances = (0, lodash_1.mapValues)(getSessionModel(), 'instance');
        onLoadSessionCallbacks.forEach(callback => callback({
            results: {
                instances,
            },
            reason,
        }));
    };
    const loadNewSession = async ({ reason } = { reason: 'noSpecificReason' }) => {
        if (isViewerFragment) {
            if (debug) {
                console.error('loadNewSession is not implemented in minisites');
            }
            return;
        }
        try {
            const newSession = await fetchDynamicModel();
            Object.assign(sessionModelState, newSession);
            invokeSessionLoadCallbacks(reason);
        }
        catch (error) {
            logger?.captureError(error, {
                tags: { feature: 'session-manager', fetchFail: 'dynamicModel' },
                extra: {
                    rawError: JSON.stringify(error),
                    stack: error.stack,
                },
            });
        }
        setSessionTimeout();
    };
    const setSessionTimeout = () => {
        if (sessionTimeoutPointer) {
            window.clearTimeout(sessionTimeoutPointer);
        }
        sessionTimeoutPointer = window.setTimeout(() => loadNewSession({ reason: 'expiry' }), constants_1.DEFAULT_EXPIRATION_TIME);
    };
    const getAppInstanceByAppDefId = (appDefId) => {
        const app = getSessionModel()[appDefId] || {};
        return app.instance;
    };
    const getSiteMemberId = () => site.userId;
    const getContactId = () => site.userId;
    const getVisitorId = noop;
    if (!isViewerFragment) {
        // set initial timeout for refresh
        setSessionTimeout();
    }
    return {
        getAllInstances() {
            return getSessionModel();
        },
        getAppInstanceByAppDefId,
        getSiteMemberId,
        getSmToken: noop,
        getVisitorId,
        loadNewSession,
        addLoadNewSessionCallback,
        getHubSecurityToken() {
            return 'NO_HS';
        },
        getUserSession() {
            return '';
        },
        getCtToken: noop,
        setUserSession() { },
        getContactId,
    };
};
exports.createEditorSessionManager = createEditorSessionManager;
//# sourceMappingURL=editorSessionManager.js.map